const hosting = {
  id: '1000',
  account_id: '1',
  brand: 'bluehost',
  platform: 'jarvis',
  username: 'mocked',
  status: 'active',
  type: 'shared',
  advanced: false,
  billing: {
    product_name: 'WordPress Basic (Hosting)',
  },
  plan: 'WordPress Basic Hosting',
  plan_key: 'basic',
  panel: 'cpanel',
};

const vpsHostingData = {
  id: '2000',
  account_id: '2',
  brand: 'bluehost',
  platform: 'jarvis',
  username: 'qpcojtmy',
  status: 'pending_create',
  type: 'vps',
  advanced: true,
  billing: { product_name: 'VPS Hosting Enhanced' },
  panel: 'unknown',
  plan_key: 'vps_20',
};

const dedicatedHostingData = {
  id: '3000',
  account_id: '3',
  brand: 'bluehost',
  platform: 'jarvis',
  username: 'yzwojtmy',
  status: 'failed_create',
  type: 'dedicated',
  advanced: true,
  billing: { product_name: 'Dedicated Hosting Enhanced HDD' },
  panel: 'unknown',
  plan_key: 'dedicated_20_hdd',
};

const resellerHostingData = {
  id: '4000',
  account_id: '4',
  brand: 'bluehost',
  platform: 'jarvis',
  username: 'vvsf1wa3',
  status: 'active',
  type: 'reseller',
  advanced: false,
  billing: {
    product_name: '',
  },
  panel: 'cpanel',
  plan_key: '',
};

const expiredHostingData = {
  id: '5000',
  account_id: '1',
  brand: 'bluehost',
  platform: 'jarvis',
  username: 'mocked',
  status: 'decom',
  type: 'shared',
  advanced: false,
  billing: {
    product_name: 'WordPress Basic (Hosting)',
  },
  plan: 'WordPress Basic Hosting',
  plan_key: 'basic',
  panel: 'cpanel',
};

const wpCloudHosting = {
  id: '6000',
  account_id: '1',
  brand: 'bluehost',
  platform: 'jarvis',
  username: 'mocked',
  status: 'active',
  type: 'cluster_atomic',
  advanced: false,
  billing: {
    product_name: 'WordPress Cloud (Hosting)',
  },
  plan: 'WordPress Cloud Hosting',
  plan_key: 'wp_cloud', // atomic_10
  panel: 'cpanel',
  resources: {
    storage: {
      available: 100,
      total: 125,
      unit: 'GB',
      used: 25,
    },
    workers: {
      available: 8,
      total: 10,
      used: 2,
    },
  },
};

const wpCloudSuspendedHosting = {
  id: '7000',
  account_id: '1',
  brand: 'bluehost',
  platform: 'jarvis',
  username: 'mocked',
  status: 'disabled',
  type: 'cluster_atomic',
  advanced: false,
  billing: {
    product_name: 'WordPress Cloud (Hosting)',
  },
  plan: 'WordPress Cloud Hosting',
  plan_key: 'wp_cloud', // atomic_10
  panel: 'cpanel',
  resources: {
    storage: {
      available: 100,
      total: 125,
      unit: 'GB',
      used: 25,
    },
    workers: {
      available: 8,
      total: 10,
      used: 2,
    },
  },
};

const destinyHostingData = {
  id: '8000',
  account_id: '1',
  brand: 'bluehost',
  platform: 'jarvis',
  username: 'mocked',
  status: 'active',
  type: 'shared',
  advanced: false,
  billing: {
    product_name: 'WordPress Basic (Hosting)',
  },
  plan: 'WordPress Basic Hosting',
  plan_key: 'basic',
  panel: 'destiny',
};

const vpsStandardHostingData = {
  id: '9000',
  account_id: '2',
  brand: 'bluehost',
  platform: 'jarvis',
  username: 'qpcojtmy',
  status: 'active',
  type: 'vps',
  advanced: true,
  billing: { product_name: 'VPS Hosting Enhanced' },
  panel: 'unknown',
  plan_key: 'vps_20',
};

const dedicatedStandardHostingData = {
  id: '10000',
  account_id: '3',
  brand: 'bluehost',
  platform: 'jarvis',
  username: 'yzwojtmy',
  status: 'active',
  type: 'dedicated',
  advanced: true,
  billing: { product_name: 'Dedicated Hosting Enhanced HDD' },
  panel: 'unknown',
  plan_key: 'dedicated_20_hdd',
};

const plans = {
  1000: hosting,
  2000: vpsHostingData,
  3000: dedicatedHostingData,
  4000: resellerHostingData,
  5000: expiredHostingData,
  6000: wpCloudHosting,
  7000: wpCloudSuspendedHosting,
  8000: destinyHostingData,
  9000: vpsStandardHostingData,
  10000: dedicatedStandardHostingData,
};

export const getMockHostingById = (id: any) => {
  var hostingId = Number(id);
  if (hostingId >= 10000 && hostingId < 11000) return plans[10000];
  if (hostingId >= 9000 && hostingId < 10000) return plans[9000];
  if (hostingId >= 8000 && hostingId < 9000) return plans[8000];
  if (hostingId >= 7000 && hostingId < 8000) return plans[7000];
  if (hostingId >= 6000 && hostingId < 7000) return plans[6000];
  if (hostingId >= 5000 && hostingId < 6000) return plans[5000];
  if (hostingId >= 4000 && hostingId < 5000) return plans[4000];
  else if (hostingId >= 3000 && hostingId < 4000) return plans[3000];
  else if (hostingId >= 2000 && hostingId < 3000) return plans[2000];
  else return plans[1000];
};

export default hosting;
